//This module assumes UTC and you should too
//The purpose of this store is to provide a reactive way to detect a change in date

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

import { SETUP_TIME_DATA } from "./actions.type";
import { SET_TODAY } from "./mutations.type";

let dayTransitionTimer = null;

const STATE = {
  today: dayjs.utc().format("YYYY-MM-DD"),
};

const GETTERS = {
  today: (state) => state.today,
};

function _getDelayUntilTomorrow() {
  let tomorrow = dayjs.utc().add("1", "day").startOf("day");
  let now = dayjs.utc();
  let timeTillTomorrow = tomorrow.diff(now);
  return timeTillTomorrow;
}

function _getTodayFormatted() {
  return dayjs.utc().format("YYYY-MM-DD");
}

function _handleDayTransition(context, params) {
  context.commit(SET_TODAY, _getTodayFormatted());
  dayTransitionTimer = setTimeout(() => {
    _handleDayTransition(context, params);
  }, _getDelayUntilTomorrow());
}

const ACTIONS = {
  [SETUP_TIME_DATA](context, params) {
    //In case setup is called twice
    clearInterval(dayTransitionTimer);
    _handleDayTransition(context, params);
  },
};

const MUTATIONS = {
  [SET_TODAY](state, data) {
    state.today = data;
  },
};

export default {
  namespaced: true,
  state: STATE,
  actions: ACTIONS,
  mutations: MUTATIONS,
  getters: GETTERS,
};
